import {
	BotTradeHistoryDto,
	CanMakeAutoTradesDto,
	GetBotTradesDto,
	GetTradesListDto,
	GetTradesParamsDto,
	MakeTradeDto,
	StartTradingBotDto,
	TradesEventFilterDto,
} from '@sportspredict/shared';
import api from './base-api';

const tradesApi = api.injectEndpoints({
	endpoints: (builder) => ({
		// PUBLIC
		getTradesByMarket: builder.query({
			query: ({ id }: any) => ({
				url: `trades/market/${id}`,
				method: 'GET',
			}),
		}),
		setSeenAutoTrade: builder.mutation({
			query: ({ tradeId }: any) => ({
				url: `trades/${tradeId}/seen-auto-trade`,
				method: 'POST',
			}),
			extraOptions: { skipAuth: true },
		}),

		// PRIVATE
		getUserTradesCount: builder.query({
			query: () => ({
				url: 'trades/user-trades-count',
				method: 'GET',
			}),
		}),
		getUserTradesCountByCategory: builder.query({
			query: ({ eventId }: any) => ({
				url: `trades/user-trades-count-category?eventId=${eventId}`,
				method: 'GET',
			}),
		}),
		getHasSecondChanceTrades: builder.query({
			query: ({ lobbyId }: any) => ({
				url: '/trades/second-chance-trades',
				method: 'GET',
				params: { lobbyId },
			}),
		}),
		// ADMIN
		canMakeAutoTrades: builder.mutation<unknown, CanMakeAutoTradesDto>({
			query: (body) => ({
				url: 'trades/auto-trades',
				method: 'POST',
				body,
			}),
		}),
		getBotTrades: builder.query<BotTradeHistoryDto[], GetBotTradesDto>({
			query: (params) => ({
				url: 'bot-trades',
				method: 'GET',
				params,
			}),
			providesTags: ['BotTrade'],
		}),
		startTradingBot: builder.mutation<void, StartTradingBotDto>({
			query: (data) => ({
				url: 'bot-trades/start',
				method: 'POST',
				body: data,
			}),
			invalidatesTags: ['Market', 'BotTrade'],
		}),
		getTradesStat: builder.query<any, TradesEventFilterDto>({
			query: (data) => ({
				url: '/trades/stat',
				method: 'POST',
				body: data,
			}),
		}),
		getTradesList: builder.query<any, GetTradesListDto>({
			query: (data) => ({
				url: '/trades/list',
				method: 'POST',
				body: data,
			}),
		}),
		getTrades: builder.query({
			query: (params: GetTradesParamsDto) => {
				return { url: 'trades', method: 'GET', params };
			},
		}),
		makeTrade: builder.mutation<{ market: unknown; trade: unknown }, MakeTradeDto>({
			query: (body) => ({
				url: 'trades/make',
				method: 'POST',
				body,
			}),
		}),
		makeBulkTrades: builder.mutation<
			{ placedMarketIds: string[]; failedMarketIds: string[] },
			{
				lobbyId: string;
				trades: { marketId: string; position: string }[];
				isFirstMatchTrade?: boolean;
			}
		>({
			query: (body) => ({
				url: 'trades/make-bulk',
				method: 'POST',
				body,
			}),
		}),
	}),
});

export default tradesApi;

export const {
	useGetBotTradesQuery,
	useLazyGetBotTradesQuery,
	useCanMakeAutoTradesMutation,
	useSetSeenAutoTradeMutation,
	useStartTradingBotMutation,
	useGetTradesListQuery,
	useGetTradesStatQuery,
	useGetHasSecondChanceTradesQuery,
	useGetUserTradesCountQuery,
	useLazyGetTradesByMarketQuery,
	useGetUserTradesCountByCategoryQuery,
	useGetTradesQuery,
	useLazyGetTradesQuery,
	useMakeTradeMutation,
	useMakeBulkTradesMutation,
} = tradesApi;
